export enum GlobalAlertTypes {
  Default = 'default',
  Information = 'information',
  Warning = 'warning',
  Error = 'error',
}

export enum GlobalAlertsVisibility {
  All = 'All',
  Quotes = 'Quotes',
  SelfService = 'Self Service',
}
